import {
    CHANGE_STEP,
    UPDATE_STEP,
    COMPLETE_SETUP_REQUEST,
    COMPLETE_SETUP_SUCCESS,
    COMPLETE_SETUP_FAILURE,
    DECREASE_TIMER,
    GET_SETUP_STATE_REQUEST,
    GET_SETUP_STATE_SUCCESS,
    GET_SETUP_STATE_FAILURE,
    RESEND_VERIFICATION_CODE_REQUEST,
    RESEND_VERIFICATION_CODE_SUCCESS,
    RESEND_VERIFICATION_CODE_FAILURE,
    ACTIVATE_DENWA_NANO_REQUEST,
    ACTIVATE_DENWA_NANO_SUCCESS,
    ACTIVATE_DENWA_NANO_FAILURE,
    SET_LICENCE_STATUS
} from './wizardActionTypes';

export const changeStep = nextStep => ({
    type: CHANGE_STEP,
    payload: { nextStep }
});

export const updateStep = data => ({
    type: UPDATE_STEP,
    payload: { data }
});

export const decreaseTimer = value => ({
    type: DECREASE_TIMER,
    payload: { value }
});

export const completeSetup = configuration => ({
    type: COMPLETE_SETUP_REQUEST,
    payload: { configuration }
});

export const completeSetupSuccess = companyEmail => ({
    type: COMPLETE_SETUP_SUCCESS,
    payload: { companyEmail }
});

export const completeSetupFailure = () => ({
    type: COMPLETE_SETUP_FAILURE,
    payload: new Error(),
    error: true
});

export const getSetupStateRequest = configuration => ({
    type: GET_SETUP_STATE_REQUEST,
    payload: { configuration }
});

export const getSetupStateSuccess = () => ({ type: GET_SETUP_STATE_SUCCESS });

export const getSetupStateFailure = () => ({
    type: GET_SETUP_STATE_FAILURE,
    payload: new Error(),
    error: true
});

export const resendVerificationCodeRequest = email => ({
    type: RESEND_VERIFICATION_CODE_REQUEST,
    payload: { email }
});

export const resendVerificationCodeSuccess = email => ({
    type: RESEND_VERIFICATION_CODE_SUCCESS,
    payload: { email }
});

export const resendVerificationCodeFailure = () => ({
    type: RESEND_VERIFICATION_CODE_FAILURE,
    payload: new Error(),
    error: true
});

export const activateDenwaNanoRequest = activationCode => ({
    type: ACTIVATE_DENWA_NANO_REQUEST,
    payload: { activationCode }
});

export const activateDenwaNanoSuccess = activationCode => ({
    type: ACTIVATE_DENWA_NANO_SUCCESS,
    payload: { activationCode }
});

export const activateDenwaNanoFailure = () => ({
    type: ACTIVATE_DENWA_NANO_FAILURE,
    payload: new Error(),
    error: true
});

export const setLicenceStatus = licenceStatus => ({
    type: SET_LICENCE_STATUS,
    payload: { licenceStatus }
});
